import { memo } from 'react';
import { useTranslation } from '@aimsos/i18n';
import { Badge, CartContainer } from '@aimsos/ui';

/** One side of a conflict: who said it, how, where, and the quote (CT-5718). */
const ConflictStatement = memo(function ConflictStatement({ statement }) {
  const { t } = useTranslation('unified-profiles');

  return (
    <CartContainer size="S" variant="neutral">
      <div className="flex flex-col gap-1 text-sm">
        <div className="flex flex-wrap items-center gap-2">
          <span className="font-medium text-content">{statement.person}</span>
          {statement.sourceType ? (
            <Badge variant="neutral" size="small">
              {t(`knowledge.sourceTypes.${statement.sourceType}`)}
            </Badge>
          ) : null}
        </div>
        {statement.source ? <span className="text-xs text-content-muted">{statement.source}</span> : null}
        {statement.quote ? <p className="text-content-secondary">“{statement.quote}”</p> : null}
      </div>
    </CartContainer>
  );
});

export default ConflictStatement;
